// extracted by mini-css-extract-plugin
export default {"loginTitle":"LoginHead_loginTitle__T2M2g","loginLogo":"LoginHead_loginLogo__n2h5C","warroomLogo":"LoginHead_warroomLogo__grjod"};